import React, { useRef, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import API from "../api/api";
import "./CheckPP.css";

function ConvertPP({
    setAnalysisData,
    setAnalyzeLoading,
    setModalOpen,
    setLoading,
    loading,
    convertLoading,
    resetBeforeAnalyze,
}) {
    const [pdfInputs, setPdfInputs] = useState([{ id: Date.now(), files: [] }]);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("info");

    const pdfInputRefs = useRef({});

    const showSnackbar = (msg, severity = "info") => {
        setSnackbarMessage(msg);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const getPdfCount = (files) => {
        if (!files || files.length === 0) return "Файлов: 0";
        return `Файлов: ${files.length}`;
    };

    const getPdfNamesPreview = (files) => {
        if (!files || files.length === 0) return "Файлы не выбраны";
        if (files.length === 1) return files[0].name;
        if (files.length === 2) return `${files[0].name}, ${files[1].name}`;
        return `${files[0].name}, ${files[1].name} +${files.length - 2}`;
    };

    const handleFilesChange = (index, files) => {
        const updated = [...pdfInputs];
        updated[index].files = Array.from(files);
        setPdfInputs(updated);
    };

    const addPdfInput = () => {
        setPdfInputs((prev) => [
            ...prev,
            { id: Date.now() + Math.random(), files: [] }
        ]);
    };

    const removePdfInput = (id) => {
        if (pdfInputs.length === 1) return;

        const inputEl = pdfInputRefs.current[id];
        if (inputEl) {
            inputEl.value = "";
        }

        setPdfInputs((prev) => prev.filter((input) => input.id !== id));
        delete pdfInputRefs.current[id];
    };

    const clearPdfInput = (index, id) => {
        const updated = [...pdfInputs];
        updated[index].files = [];
        setPdfInputs(updated);

        const inputEl = pdfInputRefs.current[id];
        if (inputEl) {
            inputEl.value = "";
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loading) {
            return showSnackbar("Предварительный анализ уже выполняется", "warning");
        }

        if (convertLoading) {
            return showSnackbar("Идет конвертация, подождите...", "warning");
        }

        const allFiles = pdfInputs.flatMap((input) => input.files);

        if (!allFiles.length) {
            return showSnackbar("Добавьте PDF файлы", "error");
        }

        const MAX_TOTAL_FILES = 200;
        if (allFiles.length > MAX_TOTAL_FILES) {
            return showSnackbar(
                `Превышено допустимое количество файлов: максимум ${MAX_TOTAL_FILES}, выбрано ${allFiles.length}`,
                "error"
            );
        }

        const formData = new FormData();
        allFiles.forEach((file) => formData.append("pdf_files", file));

        resetBeforeAnalyze();

        setLoading(true);
        setAnalyzeLoading(true);
        setModalOpen(true);

        try {
            const response = await API.post("/checker/analyze-convert-pp/", formData);
            const data = response.data;

            const filesMap = {};
            allFiles.forEach((file) => {
                filesMap[file.name] = file;
            });

            const files_ready = (data.files_ready || []).map((fileInfo) => ({
                ...fileInfo,
                fileObj: filesMap[fileInfo.file] || null,
            }));

            setAnalysisData({
                ...data,
                files: allFiles,
                files_ready,
            });

            showSnackbar("Предварительный анализ завершен", "success");
        } catch (error) {
            console.error(error);
            setModalOpen(false);

            const message =
                error.response?.data?.error || "Ошибка соединения";

            showSnackbar(message, "error");
        } finally {
            setAnalyzeLoading(false);
            setLoading(false);
        }
    };

    return (
        <section className="checkpp-shell">
            <div className="checkpp-card">
                <div className="checkpp-topbar">
                    <div className="checkpp-badge">Конвертация платежных поручений</div>
                    <h2 className="checkpp-title">Список сотрудников и выплат из банка</h2>
                </div>

                <div className="checkpp-body">
                    <form onSubmit={handleSubmit}>
                        <div className="checkpp-grid convert-grid-single">
                            <div className="checkpp-panel">
                                <div className="panel-header">
                                    <div>
                                        <div className="panel-kicker">Источник</div>
                                        <div className="panel-title">PDF банка</div>
                                    </div>

                                    <button
                                        type="button"
                                        className="panel-add-btn"
                                        onClick={addPdfInput}
                                    >
                                        + еще
                                    </button>
                                </div>

                                <div className="upload-list">
                                    {pdfInputs.map((input, index) => (
                                        <div key={input.id} className="upload-item">
                                            <div className="upload-item-head">
                                                <div className="upload-item-labels">
                                                    <span className="upload-item-title">
                                                        Блок {index + 1}
                                                    </span>
                                                    <span className="upload-item-count">
                                                        {getPdfCount(input.files)}
                                                    </span>
                                                </div>

                                                <div className="upload-item-actions">
                                                    {input.files?.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn-secondary"
                                                            onClick={() => clearPdfInput(index, input.id)}
                                                        >
                                                            очистить
                                                        </button>
                                                    )}

                                                    {pdfInputs.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn-remove"
                                                            onClick={() => removePdfInput(input.id)}
                                                        >
                                                            удалить
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="upload-row">
                                                <label className="file-btn">
                                                    Выбрать PDF
                                                    <input
                                                        ref={(el) => {
                                                            if (el) {
                                                                pdfInputRefs.current[input.id] = el;
                                                            }
                                                        }}
                                                        type="file"
                                                        accept=".pdf"
                                                        multiple
                                                        onChange={(e) =>
                                                            handleFilesChange(index, e.target.files)
                                                        }
                                                        hidden
                                                    />
                                                </label>

                                                <div className="file-preview">
                                                    {getPdfNamesPreview(input.files)}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button
                                type="submit"
                                className="btn-primary"
                                disabled={loading || convertLoading}
                            >
                                {loading
                                    ? "Идет предварительный анализ..."
                                    : convertLoading
                                        ? "Идет конвертация..."
                                        : "Предварительный анализ"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{ top: "72px" }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </section>
    );
}

export default ConvertPP;